import { useState, useEffect } from "react";
import { fetchEstimatesForUsers } from "../../../actions/client/estimates";
import Badge from "../../../components/admin/Badge";
import { Link } from "react-router-dom";
import FilterIcon from "../../../utils/assets/client/filter.svg";

const ManageEstimate = () => {
  const [estimateData, setEstimateData] = useState([]);
  const [SearchData, setSearchData] = useState({
    estimateId: "",
    name: "",
    email: "",
    status: "",
    date: "" 
  })
  const [estimateSearch, setEstimateSearch] = useState([])

  console.log(SearchData);
  useEffect(() => {
    const token = localStorage.getItem("token");

    fetchEstimatesForUsers(token).then((res) => {
      setEstimateData(res.data);
      setEstimateSearch(res.data)
      console.log(res);
    });
  }, []);

  const handleFilterChange = (values) => {
    // Update filters state

    // Filter data
    const filtered = estimateData.filter((item) => {
      const idMatch =
        !SearchData.estimateId ||
        item.id == SearchData.estimateId;

      const nameMatch =
        !SearchData.name ||
        item.lead.customer.first_name.toLowerCase().includes(values.nameOrID.toLowerCase()) &&
        item.lead.customer.last_name.toLowerCase().includes(values.nameOrID.toLowerCase()) 

      const emailMatch =
        !SearchData.email ||
        item.lead.customer.email.toLowerCase().includes(SearchData.email.toLowerCase());

      const StatusMatch =
        !SearchData.status ||
        item.status.toLowerCase().includes(SearchData.status.toLowerCase());

        const dateMatch = 
        !SearchData.date ||
        new Date(item.created_at).toISOString().slice(0, 10) === SearchData.date;

      return idMatch && nameMatch && emailMatch && StatusMatch && dateMatch;
    });

    setEstimateSearch(filtered)
    // setIsLoading(true)
    // setTimeout(() => {
    // setFilteredData(filtered);
    // setIsLoading(false)
    // }, 1000)
  };

  
  return (
    <div className="py-3 px-4 bg-light">
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Manage Estimates</h4>
        <button className="btn  bg-black text-white py-2 px-3 border-0">
          Create Ticket
        </button>
      </div>
      <div className="">
      <div className="card_radius bg-white my-3 p-3">
        <div className="row d-flex justify-content-start align-items-center">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Estimate ID</label>
            <input type="text" className="form-control" 
              value={SearchData.estimateId} 
              onChange={(e) => setSearchData({...SearchData, estimateId: e.target.value})} 
              placeholder="Enter ID" />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Customer Name</label>
            <input
              type="text"
              className="form-control"
              value={SearchData.name} 
              onChange={(e) => setSearchData({...SearchData, name: e.target.value})} 
              placeholder="Enter customer name"
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Customer Email</label>
            <input type="text" className="form-control"
              value={SearchData.email} 
              onChange={(e) => setSearchData({...SearchData, email: e.target.value})} 
            placeholder="Enter Email" />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Status</label>
            <input type="text" className="form-control"
              value={SearchData.status} 
              onChange={(e) => setSearchData({...SearchData, status: e.target.value})} 
            placeholder="Enter Status" />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
            <label className="form-label">Created Date</label>
            <input type="date" className="form-control"
              value={SearchData.date} 
              onChange={(e) => setSearchData({...SearchData, date: e.target.value})} 
            placeholder="Enter date" />
          </div>
        </div>
        <div className="my-1">
          <button className="btn btn-sm bg-black  text-white p-2 px-3 border-0">
            <img width={20} src={FilterIcon} alt="filter" />{" "}
            <span>Clear Filter</span>
          </button>
          <button onClick={handleFilterChange} className="btn btn-sm bg-black text-white py-2 px-3 mx-2 border-0">
            Search
          </button>
        </div>
      </div>
      </div>
      

      <div className="">
        <div className="   overflow-hidden">
          <p className="txt-head  bg-black text-white mb-0 p-2 px-3">
            View Estimates
          </p>
          <table className="table   table-hover mb-0">
            <thead>
              <tr className="p-2 ">
                <td className="px-3">Id</td>
                <td className="">Product/Service</td>
                <td>Customer</td>
                <td>Lead Reference</td>
                <td>Created Date</td>
                <td>Total</td>
                <td>Status</td>
                <td>Actions</td>
              </tr>
            </thead>
            <tbody>
              {estimateSearch.length > 0
                ? estimateSearch.map((item) => {
                    return (
                      <tr className="p-2 text-black" key={item.id}>
                        <td className="px-3">
                          <Link
                            className="link_text"
                            to={`/admin/estimates/${item.id}`}
                            style={{fontWeight: "400"}}
                          >
                            {item.id}
                          </Link>
                        </td>
                        <td className="">
                          {item.lead.lead_items &&
                            item.lead.lead_items.map((res) => {
                              return (
                                <div
                                  className="d-flex flex-column"
                                  key={res.id}
                                >
                                  {res.defects &&
                                    res.defects.map((defect) => {
                                      return (
                                        <span key={defect.id}>
                                          {defect.title}
                                        </span>
                                      );
                                    })}
                                </div>
                              );
                            })}
                        </td>
                        <td className="">
                          <div className="d-flex flex-column">
                            <span>
                              {item.lead.customer.first_name}{" "}
                              {item.lead.customer.last_name}
                            </span>
                            <span>Email: {item.lead.customer.email}</span>
                            <span>Mobile: {item.lead.customer.phone}</span>
                          </div>
                        </td>
                        <td className="">
                          {" "}
                          <Link to={`/admin/leads/${item.lead_id}`} className="link_text">{item.lead_id}</Link>{" "}
                        </td>
                        <td className="">
                          {item.created_at
                            ? new Date(item.created_at).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                }
                              )
                            : "-"}
                        </td>
                        <td className="">£ Total</td>
                        <td className="">
                          <Badge
                            title={item.status}
                            color_code={item.color_code}
                          />
                        </td>
                        <td className="">Actions</td>
                      </tr>
                    );
                  })
                : (
                  <tr>
                    <td
                      colspan="8"
                      className="table-active text-center txt-p py-2"
                      style={{fontWeight: "500"}}
                    >
                      No Records
                    </td>
                  </tr>
                )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManageEstimate;
